import { Component, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { UnitsHelper } from 'app/services/units.helper';
import { Volume } from 'convert';
import { IBottle } from 'app/models/bottle';

import { Store } from '@ngrx/store';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import * as fromBar from 'app/state/bar';
import * as fromBeverage from 'app/state/beverage';
import * as fromBottle from 'app/state/bottle';
import { BottleService } from 'app/services/dal/bottle.service';
@Component({
  selector: 'app-new-bottle',
  templateUrl: './new-bottle.component.html',
  styleUrls: ['./new-bottle.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, ReactiveFormsModule]
})
export class NewBottleComponent implements OnInit {
  item!: IBottle | undefined;
  barId = this.store.selectSignal(fromBar.selectBarId)
  beverageId = this.store.selectSignal(fromBeverage.selectCurrentId);

  ean = this.store.selectSignal(fromBottle.selectEan);

  bottles: IBottle[] = [];
  unitType!: Volume;

  form = this.fb.group({
    count: ['', { validators: [Validators.required] }],
    location: ['',],
    selectBottle: ['']
  });

  constructor(
    private store: Store,
    private modalController: ModalController,
    public unitHelper: UnitsHelper,
    private fb: FormBuilder,
    private bottleService: BottleService
  ) { }

  ngOnInit() {
    this.populateAvailableBottles();
  }

  selectItem(event: any) {
    const item = event.detail.value as IBottle;
    item.barId = this.barId() ?? '';
    item.beverageId = this.beverageId() ?? '';

    this.dismiss(item);
  }

  closeModal() {
    this.modalController.dismiss({
      dismissed: true
    }, 'cancel');
  }

  dismiss(item: IBottle) {
    const id = this.bottleService.getNewId();
    this.store.dispatch(fromBottle.setItem({ id }));
    this.store.dispatch(fromBottle.addItem({ id, item }));

    this.modalController.dismiss({
      id: id
    }, 'open-edit');
  }

  private populateAvailableBottles() {
    this.bottles = [];
    var volume = this.unitHelper.getUnit(this.unitType);
    if (volume.system === "imperial") {
      this.bottles.push(
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 248, type: "imperial", name: "8.4oz", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 354, type: "imperial", name: "12oz", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 473, type: "imperial", name: "16oz", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 568, type: "imperial", name: "19.2oz", count: 1 }
      );
    } else {
      this.bottles.push(
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 750, type: "metric", name: "0.75l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 500, type: "metric", name: "0.50l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 440, type: "metric", name: "0.44l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 330, type: "metric", name: "0.33l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 250, type: "metric", name: "0.25l", count: 1 }
      );
    }
  }


}
